import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["rootClassName", "classes", "fieldState", "id", "label_bold", "label_normal", "label_content", "message", "breakLabels", "show_more", "label_extended"];
import React, { Component } from "react";
import { compose } from "redux";

//Style
import defaultClasses from "./checkbox.module.scss";
import classify from "@magento/venia-ui/lib/classify";

//Components
import RichContent from "@magento/venia-ui/lib/components/RichContent";
import { Message } from "../Field";
import { BasicCheckbox, asField } from "informed";
import Icon from "../../../../components/Icon";

/* TODO: change lint config to use `label-has-associated-control` */
/* eslint-disable jsx-a11y/label-has-for */

var checkedIcon = /*#__PURE__*/React.createElement(Icon, {
  name: "icon-check",
  color: "white"
});
var uncheckedIcon = null;
export class Checkbox extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isShow: false
    });
    _defineProperty(this, "setHidden", () => {
      this.setState({
        isShow: false
      });
    });
    _defineProperty(this, "setShow", () => {
      this.setState({
        isShow: true
      });
    });
  }
  render() {
    var _this$props = this.props,
      {
        rootClassName,
        classes,
        fieldState,
        id,
        label_bold,
        label_normal,
        label_content,
        message,
        breakLabels,
        show_more,
        label_extended
      } = _this$props,
      rest = _objectWithoutProperties(_this$props, _excluded);
    var {
      setShow
    } = this;
    var {
      isShow
    } = this.state;
    var {
      value: checked
    } = fieldState;
    var checkboxStyle = checked ? "input-checked ".concat(classes.inputChecked) : classes.input;
    var icon = checked ? checkedIcon : uncheckedIcon;
    return /*#__PURE__*/React.createElement("div", {
      className: "checkbox-area ".concat(classes.area)
    }, /*#__PURE__*/React.createElement("label", {
      className: "checkbox-component ".concat(classes.root, " ").concat(rootClassName ? rootClassName : "", " ").concat(breakLabels ? classes.breakLabels : ""),
      htmlFor: id
    }, /*#__PURE__*/React.createElement(BasicCheckbox, _extends({}, rest, {
      className: checkboxStyle,
      fieldState: fieldState,
      id: id
    })), /*#__PURE__*/React.createElement("span", {
      className: classes.icon
    }, icon), /*#__PURE__*/React.createElement("div", {
      className: "uk-flex uk-flex-middle"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.label_bold
    }, /*#__PURE__*/React.createElement(RichContent, {
      html: label_bold
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.label_normal
    }, label_content || /*#__PURE__*/React.createElement(RichContent, {
      html: label_normal
    })))), /*#__PURE__*/React.createElement(Message, {
      fieldState: fieldState
    }, message), show_more ? /*#__PURE__*/React.createElement("div", {
      className: "checkbox-link ".concat(classes.link),
      onClick: isShow ? () => this.setHidden() : () => setShow()
    }, show_more) : null, label_extended && isShow ? /*#__PURE__*/React.createElement("div", {
      className: "checkbox-more ".concat(classes.more)
    }, /*#__PURE__*/React.createElement(RichContent, {
      html: label_extended
    })) : null);
  }
}
export default compose(classify(defaultClasses), asField)(Checkbox);